import React, { useContext } from 'react';
import ModalAlert from 'canvas-core-react/lib/ModalAlert';
import ModalDialogue from 'canvas-core-react/lib/ModalDialogue';
import { ContextApp } from '../../../ContextApi/ContextApi';
const ModalApp = () => {
  const { globalState, dispatch } = useContext(ContextApp);

  const onClose = () => {
    dispatch('modal', { ...globalState.modal.value, isOpen: false }, true);
  };

  const handlePrimaryAction = () => {
    onClose();
    globalState.modal.value.primaryAction && globalState.modal.value.primaryAction();
  }

  const handleSecondaryAction = () => {
    onClose();
    globalState.modal.value.secondaryAction && globalState.modal.value.secondaryAction();
  }

  let modal;

  if (globalState.modal.value.type === 'alert') {
    modal = (
      <div id={`container-modal-alert`}>
        <ModalAlert
          id={`modal-alert`}
          headline={globalState.modal.value.headline}
          message={'error desconocido'}
          isModalVisible={globalState.modal.value.isOpen}
          primaryButtonLabel={globalState.modal.value.primaryButtonLabel}
          primaryAction={globalState.modal.value.primaryAction ? globalState.modal.value.primaryAction : onClose}
          setModalVisible={onClose}
        >
          {globalState.modal.value.bodyMessage}
        </ModalAlert>
      </div>
    );
  } else {
    modal = (
      <div id={`container-modal-alert`}>
        <ModalDialogue
          id={`modal-dialogue`}
          headline={globalState.modal.value.headline}
          message={'error desconocido'}
          isModalVisible={globalState.modal.value.isOpen}
          primaryButtonLabel={globalState.modal.value.primaryButtonLabel}
          primaryAction={handlePrimaryAction}
          secondaryAction={handleSecondaryAction}
          secondaryButtonLabel={globalState.modal.value.secondaryButtonLabel}
          setModalVisible={onClose}
        >
          {globalState.modal.value.bodyMessage}
        </ModalDialogue>
      </div>
    );
  }

  return modal;
};

export default ModalApp;
